import { useLocation } from 'react-router-dom';

/**
 * @description 헤더 config에 따라 뒤로가기 및 드로어 아이콘을 표시할지 체크해주는 커스텀 훅
 * @param params
 * @example
 * ```
 * const isAllowed = useHeaderConfig('paths');
 * ```
 */
export const useHeaderConfig = (paths: Array<string>): boolean => {
  const { pathname } = useLocation();
  return paths.reduce((prev: boolean, curr: string) => prev || pathname === curr, false);
};
